import './services/i18n';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingApi from './components/loading/LoadingApi';
import { ToastContainer } from 'react-toastify';
import Modals from './components/modal/Modals';
import { getStorage } from './utils/browsers';
import { formatDateTime } from './utils/datetime';
import { DISPLAY_MOMENT_DATE_YMD } from './configs/constants';
import { useStore } from './hooks/useStore';

import '/node_modules/flag-icons/css/flag-icons.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.scss';
import { scrollToTop } from './utils/utils';

export default function App() {
    // hooks
    const { i18n } = useTranslation();
    const location = useLocation();

    // store
    const { generalStore: { getAdministrativeUnit } } = useStore();

    // lifecycle
    useEffect(() => {
        // get administrative unit
        const getAdministrativeDate = getStorage('getAdministrativeDate');
        if (!getAdministrativeDate || (getAdministrativeDate !== formatDateTime(new Date(), DISPLAY_MOMENT_DATE_YMD))) {
            getAdministrativeUnit();
        }

        // Set initial language
        handleLanguageChange(i18n.language);

        // Listen for language changes
        i18n.on('languageChanged', handleLanguageChange);

        // Clean up listener on unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    // function
    const handleLanguageChange = (lng: string) => {
        document.documentElement.lang = lng;
    };

    return (
        <div className='app'>
            <Outlet />
            <LoadingApi />
            <ToastContainer />
            <Modals />
        </div>
    );
}
